import React from "react";
import BranchClusteringComponent from "../../components/branchClusteringComponents/BranchClusteringComponent";


const BranchClusteringContainer: React.FC<{ isTabSelected: boolean }> = ({isTabSelected}) => {
    return(
        <BranchClusteringComponent isTabSelected={isTabSelected} />
    )
};

export default BranchClusteringContainer;
